export function initPrescriptionPriceService(){
    let priceElement = document.getElementById('price');
    let basicPriceValue = priceElement.getAttribute('content');
    if(basicPriceValue.includes(',') === false){
        basicPriceValue += ',00';
    }
    let currencyElement = document.getElementById('priceCurrency');
    let currencyValue = currencyElement.getAttribute('content');

    let divWithPriceText = priceElement.parentElement;

    let prescriptionPaymentOptionSelect = document.getElementById('prescription_payment_options');
    if(prescriptionPaymentOptionSelect) {
        const allRadioButtons = document.querySelectorAll('[name="prescription_payment_options"]');
        allRadioButtons[0].checked = true;
        allRadioButtons[1].checked = false;
        allRadioButtons[2].checked = false;
        prescriptionPaymentOptionSelect.addEventListener('change', function (event) {
            let additionalCombos = document.getElementById('prescription_additional_fields');

            if (event.target.value === '3') {
                if (currencyValue === 'EUR') {
                    divWithPriceText.textContent = '0,00\xA0€';
                }
                additionalCombos.hidden = false;
                additionalCombos.style.display = 'flex';
            } else {
                if (currencyValue === 'EUR') {
                    divWithPriceText.textContent = basicPriceValue + '\xA0€';
                }

                additionalCombos.hidden = true;
                additionalCombos.style.display = 'none';
            }
        });

    }

}
